import React, { useEffect, useState } from 'react';
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { SnackbarActions } from '../redux/actions/snackbar.actions'



function CustomizedSnackbar(props) {
    const dispatch = useDispatch();
    let actions = useSelector(state => state.setSnackbar);

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("info");
    const [message, setMessage] = useState("");
    const [vertical, setVertical] = useState("top");
    const [horizontal, setHorizantal] = useState("center");
    const [timeOut, setTimeOut] = useState(2000)

    useEffect(() => {
        if (actions !== undefined) {
            setOpen(actions.snackbarOpen)
            setSeverity(actions.snackbarType)
            setMessage(actions.snackbarMessage)
            setVertical(actions.snackbarVertical)
            setHorizantal(actions.snackbarHorizontal)
        }
    }, [actions])

    const handleClose = (event, reason) => {
        if (event !== null) {
            if (event.type === "click") {
                dispatch(SnackbarActions(false, severity, ""));
            }
        }
        if (reason !== undefined) {

            dispatch(SnackbarActions(false, severity, ""));
        }

    }
    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: vertical, horizontal: horizontal }}
                open={open}
                onClose={handleClose}
                autoHideDuration={2000}
            >
                <Alert severity={severity} variant="filled" onClose={handleClose} elevation={6} sx={{fontWeight:"bold"}}>
                    {message}
                </Alert>
            </Snackbar>
        </div>
    )
}
export default CustomizedSnackbar;